export const SNACKBAR_DEFAULT_DURATION_MS = 4000 as const

export const SNACKBAR_IMPORT_DURATION_MS = 10000 as const
